namespace Ir.Components.Workbook.Settings.Items.TextAlignmentSetting {
    export interface ITextAlignmentSettingParams {
        label?: string;
        value: KnockoutObservable<FontAlignmentEnum>;
        disabled?: KnockoutObservable<boolean> | boolean;
        visible?: KnockoutObservable<boolean> | boolean;
    }
    interface IViewModel {
        buttonGroupOptions: DevExpress.ui.dxButtonGroup.Properties;
        label: string;
        disabled?: KnockoutObservable<boolean> | boolean;
        visible?: KnockoutObservable<boolean> | boolean;
    }

    interface IParams {
        config: ITextAlignmentSettingParams;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        this.label = params.config.label ?? "Text Alignment";
        let value = params.config.value;
        this.disabled = params.config.disabled === undefined ? false : params.config.disabled as any;
        this.visible = params.config.visible === undefined ? true : params.config.visible as any;

        this.buttonGroupOptions = {
            items: [
                {
                    icon: 'alignleft',
                    alignment: FontAlignmentEnum.Start,
                    hint: 'Align left'
                },
                {
                    icon: 'aligncenter',
                    alignment: FontAlignmentEnum.Center,
                    hint: 'Center'
                },
                {
                    icon: 'alignright',
                    alignment: FontAlignmentEnum.End,
                    hint: 'Align right'
                }
            ] as any,
            keyExpr: 'alignment',
            stylingMode: 'outlined',
            selectedItemKeys: [value()],
            onItemClick: function (e) {
                value(e.itemData.alignment);
            },
            disabled: this.disabled as any,
        };
    }
}